import { render, staticRenderFns } from "./CierreQualitas.vue?vue&type=template&id=bfa95bde&"
import script from "./CierreQualitas.vue?vue&type=script&lang=js&"
export * from "./CierreQualitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports